module.exports = __webpack_public_path__ + "img/pro12.e060480f.png";